import React, { CSSProperties } from 'react';
import "./FlowLayout.scoped.scss";

interface IFlowLayoutProps {
  header?: React.ReactElement;
  footer?: React.ReactElement;
  children: any;
  style?: CSSProperties
}

const FlowLayout: React.FC<IFlowLayoutProps> = ({ children, header, footer, style }) =>
  <div className="flow-layout" style={style}>
    {header &&
      <div className="flow-header">
        {header}
      </div>
    }
    <div className="flow-body">
      {children}
    </div>
    {footer &&
      <div className="flow-footer">
        {footer}
      </div>
    }
  </div>;

export default FlowLayout;
